import React from "react";
import Forbidden from "../../components/pages/Forbidden";
import Spinner from "../../components/utils/Spinner";
import { LogoutRequestState } from "../reducer";
import { ILogoutProps } from "./types";

export class LogoutComponent extends React.Component<ILogoutProps> {
  public componentDidMount() {
    this.props.onLogOut();
  }

  public componentDidUpdate(prevProps: ILogoutProps) {
    if (
      prevProps.logoutRequestState === LogoutRequestState.PENDING &&
      this.props.logoutRequestState === LogoutRequestState.SUCCEEDED
    ) {
      this.props.onLoggedOut();
    }
  }

  public render() {
    const {
      authenticationState: { isAuthenticated, isKnown },
    } = this.props;

    if (!isKnown) {
      return <Spinner />;
    }

    if (!isAuthenticated) {
      return <Forbidden />;
    }

    return <Spinner />;
  }
}
